import React from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

type Props = {
  label?:
    | string
    | number
    | boolean
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | React.ReactFragment
    | null;
  value: boolean | unknown;
  handleChange: (value: boolean) => void;
  handleBlur?: (value: boolean) => void;
};

function CheckboxField(props: Props) {
  const { label, value, handleChange, handleBlur, ...rest } = props;

  return (
    <FormGroup row>
      <FormControlLabel
        control={
          <Checkbox
            checked={typeof props.value === 'boolean' ? props.value : false}
            onChange={() => {
              handleChange(!value);
            }}
            inputProps={{
              onBlur: () => {
                if (handleBlur !== null && handleBlur !== undefined) {
                  handleBlur(typeof value === 'boolean' ? value : false);
                }
              },
            }}
            {...rest}
          />
        }
        label={label || ''}
      />
    </FormGroup>
  );
}

export default CheckboxField;
